import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'employeeLastApplications'
})
export class EmployeeLastApplicationsPipe implements PipeTransform {

  constructor(private datePipe: DatePipe) { }

  transform(value: string): unknown {

    if (!value) { return ''}

    const arr: Array<{ _id: number, date: string }> = JSON.parse(value);

    var dataContent = ``;

    for (let index = arr.length - 1; index >= 0; index--) {

      const e = arr[index];

      if (index === arr.length - 1) {
        dataContent += `<div class='text-left'><span class='font-weight-bolder text-left mgn-bottom-5 d-inline-block'>Última postulación: ${this.datePipe.transform(e.date, 'dd/MM/yyyy')}</span>`;
      }
      else {
        dataContent += `${index === arr.length - 2 ? `<span class='font-weight-bolder text-left mgn-bottom-5 d-inline-block'>Otras postulaciones</span><ul class='padding-left-15 text-left no-mgn'>` : ''}<li>${this.datePipe.transform(e.date, 'dd/MM/yyyy')}</li>`;
      }

      if (index === 0) {
        dataContent += `${arr.length > 1 ? '</ul>' : ''}</div>`;
      }
    }
    return dataContent;
  }
}